import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { MCButton, MCText } from 'src/components/basic';
import Config from 'src/config';

import { lang, remCss, remFontCss, withRouter } from 'src/helpers';

import model from './model';
import AccountClinicForm from './ClinicForm';

const roles = [
  { label: 'Patient', value: 'patient' },
  { label: 'Doctor', value: 'doctor' },
  { label: 'Clinic', value: 'clinic' }
];

class Accounts extends BaseComponent {
  state = { signing: null };
  componentDidMount() {
    model.subscribe(this.subscription);
    model.sessionsList();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  renderItem = (connectedAccounts, role) => {
    let account = connectedAccounts.find((item) => item.role == role.value);
    let isCurrent = account && account.id == model.getState().id;
    return (
      <div key={role.value} style={{ display: 'flex', alignItems: 'center', padding: remCss(20) }}>
        <span style={{ width: remCss(100), fontSize: remFontCss(18) }}>{role.label}</span>
        {!isCurrent && (
          <button
            className={`mc-button medium primary radius ${account ? 'light' : 'dark'}`}
            onClick={() =>
              account
                ? model.switchAccount(account.id)
                : role.value === 'clinic'
                  ? this.setState({ signing: 'clinic' })
                  : model.createAccount(role.value)
            }
          >
            {account ? 'login' : 'signup'}
          </button>
        )}
        {isCurrent && <span>current</span>}
      </div>
    );
  };

  makeCammelCase = (str) => {
    let parts = str?.toString()?.split(', ') || [];
    return parts.map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join(', ');
  };

  render() {
    if (this.state.signing === 'clinic') {
      return (
        <AccountClinicForm
          onCancel={() => {
            this.setState({ signing: null });
          }}
        />
      );
    }
    let user = model.getState().user || {};
    let connectedAccounts = user.connectedAccounts;
    if (!connectedAccounts) {
      connectedAccounts = [
        {
          id: model.getState().id,
          role: user.isDoctor ? 'doctor' : user.isClinic ? 'clinic' : 'patient'
        }
      ];
    }
    let loadingLogoutAll = model.getApiState('logoutAll').loading;
    let sessions = model.getState().sessions || [];
    let sid = Config.get('sid');
    return (
      <div className={'mc-main-content'}>
        <div className={'mc-header'}>
          <div className={'mc-title'}>{lang.t('Connected Accounts')}</div>
        </div>
        <div>{roles.map(this.renderItem.bind(this, connectedAccounts))}</div>
        <div style={{ padding: remCss(20) }}>
          <h3>Active Sessions</h3>
          {sessions.map((item) => (
            <div
              key={item.sid}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: remCss(10),
                borderBottom: '1px solid #ccc'
              }}
            >
              {!!item.deviceInfo && (
                <div>
                  {!!item.deviceInfo.browser && (
                    <MCText
                      heading
                      label={item.deviceInfo.osName + ' ' + item.deviceInfo.browser}
                    />
                  )}
                  {!item.deviceInfo.browser && (
                    <MCText
                      heading
                      label={item.deviceInfo.deviceName || item.deviceInfo.osName + ' app'}
                    />
                  )}
                  <MCText
                    style={{ paddingVertical: remCss(5) }}
                    textLight
                    label={this.makeCammelCase(item.deviceInfo.location)}
                  />
                  <MCText textLight>
                    {item.deviceInfo.ip} - {new Date(item.lastActivity).toLocaleString()}
                  </MCText>
                </div>
              )}
              {!item.deviceInfo && <MCText>{lang.t('Unknown session')}</MCText>}
              <div>
                {item.sid == sid ? (
                  <MCText primary label={'Current session'} />
                ) : (
                  <MCButton
                    small
                    light
                    radius
                    loading={item.removing}
                    disabled={item.removing}
                    onClick={() => model.logoutSid(item.sid)}
                    label={'Logout'}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: remCss(20) }}>
          <MCButton
            primary
            medium
            dark
            radius
            onClick={model.logoutAll}
            disabled={!!loadingLogoutAll}
            loading={!!loadingLogoutAll}
            label={'Logout All'}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Accounts);
